import { useMemo } from "react";
import Select from "react-select";

const PaymentFilters = ({
    filters,
    setFilters,
    onSearch,
    paymentModes,
    tiers,
    tierLabel
}) => {
    const tierOptions = useMemo(
        () =>
            tiers.map(tier => ({
                value: tier.id,
                label: tier.name
            })),
        [tiers]
    );
    const handleChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div className="card shadow-sm mb-4 p-3">

            <div className="row align-items-center">

                {/* Mode */}
                <div className="col-md-3">
                    <div className="d-flex align-items-center gap-2">
                        <label className="mb-0 fw-semibold" style={{ minWidth: "80px" }}>
                            Mode
                        </label>
                        <select
                            className="form-select"
                            value={filters.paymentModeId || ""}
                            onChange={e => handleChange("paymentModeId", e.target.value)}
                        >
                            <option value="">Tous</option>
                            {paymentModes.map(m => (
                                <option key={m.id} value={m.id}>
                                    {m.nameLat}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Tier */}
                <div className="col-md-3">
                    <div className="d-flex align-items-center gap-2">
                        <label
                            className="mb-0 fw-semibold"
                            style={{ minWidth: "80px" }}
                        >
                            {/* {tierLabel} */}Tiers
                        </label>

                        <Select
                            className="flex-grow-1"
                            options={tierOptions}
                            placeholder="Tous"
                            isClearable
                            value={
                                tierOptions.find(
                                    x => x.value === Number(filters.tierId)
                                ) || null
                            }
                            onChange={selected =>
                                handleChange(
                                    "tierId",
                                    selected ? selected.value : ""
                                )
                            }
                        />
                    </div>
                </div>

                {/* Min */}
                <div className="col-md-2">
                    <div className="d-flex align-items-center gap-2">
                        <label className="mb-0 fw-semibold" style={{ minWidth: "40px" }}>
                            Min
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            value={filters.minAmount || ""}
                            onChange={e => handleChange("minAmount", e.target.value)}
                        />
                    </div>
                </div>

                {/* Max */}
                <div className="col-md-2">
                    <div className="d-flex align-items-center gap-2">
                        <label className="mb-0 fw-semibold" style={{ minWidth: "40px" }}>
                            Max
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            value={filters.maxAmount || ""}
                            onChange={e => handleChange("maxAmount", e.target.value)}
                        />
                    </div>
                </div>

                {/* Button */}
                <div className="col-md-2 text-end">
                    <button className="btn btn-primary w-100" onClick={onSearch}>
                        🔍 Rechercher
                    </button>
                </div>

            </div>

        </div>
    );
};

export default PaymentFilters;